module.exports = __webpack_public_path__ + "static/media/Discrete Structures.07e2e0dd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MAT/Discrete Structures.pdf
// module id = 128
// module chunks = 0